import React from 'react';
import { ErrorMessage } from 'helper/ui-helper';
import { FormActionsAccount } from 'helper/bootstrap-helper';
import LayoutLoader from 'component/LayoutLoader/LayoutLoader';
import RoutePath from 'constants/routePath';
import { Link } from 'react-router';
import classnames from 'classnames';

export const KutubeeLoginFormTemplate =
  ({ t, formRef, emailFieldRef, passwordFieldRef, onSubmit, isLoading, errorMessage }) => {
    return (
      <form
        className="smart-form client-form"
        ref={(form) => {formRef(form)}}
        onSubmit={onSubmit}
      >
        <LayoutLoader display-if={isLoading} />
        
        <fieldset>
          <ErrorMessage display-if={errorMessage} errorMessage={errorMessage} />
  
          <label className="client-form__label">
            <i className="client-form__icon fa fa-user" aria-hidden="true" />
            <input
              type="text"
              name="email"
              className="form-control client-form__input"
              ref={(input) => emailFieldRef(input)}
              aria-label="Login"
            />
          </label>
  
          <label className="client-form__label">
            <i className="client-form__icon fa fa-lock" aria-hidden="true" />
            <input
              type="password"
              name="password"
              className="form-control client-form__input"
              ref={(input) => passwordFieldRef(input)}
              aria-label="password"
            />
          </label>
            
            <div className="note">
              <Link to={RoutePath.ROUTE_FORGOT_PASSWORD}>
                {t("Forgot password?")}
              </Link>
            </div>
        </fieldset>
        
        <FormActionsAccount>
          <button
            className={classnames("btn btn-primary", { disabled: isLoading })}
            type="submit"
          >
            {t("Sign in")}
          </button>
        </FormActionsAccount>
      </form>
    );
  };
